module.exports = __webpack_public_path__ + "img/s2-img1.37a2388.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lifeHome/s2-img1.jpg
// module id = 407
// module chunks = 0